export default __webpack_public_path__ + "static/media/detail-note1.4c28efa5.svg";